/* eslint-disable no-shadow,react/no-array-index-key  */
import React, {
  useEffect,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Col,
  Form,
  Row,
} from 'react-bootstrap';
import { Field } from 'formik';
import _ from 'lodash';
import TextareaAutosize from 'react-textarea-autosize';

import {
  ACTIVITY_TYPES,
} from '../../helpers/atworks';
import { useTranslation } from '../hooks/useTranslation';
import ArtSelect from './ArtSelect';
import ArtField from './ArtField';
import {
  ButtonControl,
  DefaultLabel,
  H3,
} from '../../helpers/accountStyles';

const ArtActivity = ({
  form,
  form: { setFieldValue },
  name,
  push,
  remove,
  label,
  labelOutside,
  className,
}) => {
  const { t } = useTranslation();
  const [values, setValues] = useState({});

  const handleChangeFor = (propertyName, value, isNumber = false) => {
    if (isNumber) {
      if (value) {
        const newText = value.trim().replace(',', '.');
        const is = /^[\d]{0,10}?[.]?([\d]{0,2})$/.test(newText);
        if (is) {
          setValues({ ...values, [propertyName]: newText });
          setFieldValue(propertyName, newText);
          return true;
        }
        return false;
      }
      setValues({ ...values, [propertyName]: '' });
      setFieldValue(propertyName, '');
      return true;
    }
    setValues({ ...values, [propertyName]: value });
    setFieldValue(propertyName, value);
    return true;
  };

  useEffect(() => {
    setValues(_.get(form, 'values'));
  }, [_.get(form, 'values')]);

  return (
    <div id="activity">
      {labelOutside && label}
      <Form.Group controlId={name}>
        {_.get(values, `${name}`, []).map((item, index) => {
          let errors = null;
          if (!!form.errors
            && !!form.errors[name]
            && !!form.errors[name][index]) {
            errors = form.errors[name][index];
          }
          return (
            <div
              key={`activity-${name}-${index}`}
              className={className}
            >
              {_.get(errors, 'main') && (
                <div className="badge badge-pill position-absolute mt-n4 badge-danger">
                  {errors.main}
                </div>
              )}

              <Field
                label={(<H3 start={1}>{t('activities_type', { ns: 'secret' })}</H3>)}
                component={ArtSelect}
                column
                placeholder={t('activities_type_placeholder', { ns: 'secret' })}
                name={`${name}.${index}.type`}
                defaultValue={
                      Object
                        .keys(ACTIVITY_TYPES)
                        .map((value) => ({ label: ACTIVITY_TYPES[value], value }))
                        .filter((o) => _.get(values, `${name}[${index}].type`) === o.value)
                    }
                options={Object.keys(ACTIVITY_TYPES).map((value) => ({
                  label: ACTIVITY_TYPES[value], value,
                }))}
                isMulti={false}
                onChange={(val) => handleChangeFor(`${name}.${index}.type`, val.value)}
                className={`form-control border-0 form-control-lg ${_.get(errors, 'type') ? 'is-invalid' : ''}`}
              />

              {_.get(errors, 'type') && (
                <div className="badge position-absolute mt-n4 badge-pill badge-danger">
                  {_.get(errors, 'type')}
                </div>
              )}

              <Row>
                <Col lg={6}>
                  <H3 start={0}>
                    {t('activities_activity', { ns: 'secret' })}
                    <DefaultLabel>
                      {t('not_necessary', { ns: 'index' })}
                    </DefaultLabel>
                  </H3>
                  <Field
                    name={`${name}[${index}].name`}
                    placeholder={t('activities_activity_placeholder', { ns: 'secret' })}
                    className="form-control-lg"
                    value={_.get(values, `${name}[${index}].name`)}
                    onChange={(e) => handleChangeFor(`${name}[${index}].name`, _.get(e, 'target.value', ''))}
                    component={ArtField}
                  />
                </Col>
                <Col lg={6}>
                  <H3 start={0}>
                    {t('activities_period', { ns: 'secret' })}
                    <DefaultLabel>
                      {t('not_necessary', { ns: 'index' })}
                    </DefaultLabel>
                  </H3>
                  <Field
                    name={`${name}[${index}].dates`}
                    placeholder={t('period_placeholder', { ns: 'secret' })}
                    className="form-control-lg"
                    value={_.get(values, `${name}[${index}].dates`)}
                    onChange={(e) => handleChangeFor(`${name}[${index}].dates`, _.get(e, 'target.value', ''))}
                    component={ArtField}
                  />
                </Col>
              </Row>

              {_.get(errors, 'name') && (
                <div className="badge position-absolute mt-n4 badge-pill badge-danger">
                  {_.get(errors, 'name')}
                </div>
              )}
              {_.get(errors, 'dates') && (
                <div className="badge position-absolute mt-n4 badge-pill badge-danger">
                  {_.get(errors, 'dates')}
                </div>
              )}

              <H3 start={0}>
                {t('activities_link', { ns: 'secret' })}
                <DefaultLabel>
                  {t('not_necessary', { ns: 'index' })}
                </DefaultLabel>
              </H3>
              <Field
                name={`${name}[${index}].link`}
                placeholder={t('activities_link_placeholder', { ns: 'secret' })}
                className="form-control-lg"
                value={_.get(values, `${name}[${index}].link`)}
                onChange={(e) => handleChangeFor(`${name}[${index}].link`, _.get(e, 'target.value', ''))}
                component={ArtField}
              />

              {_.get(errors, 'link') && (
                <div className="badge position-absolute mt-n4 badge-pill badge-danger">
                  {_.get(errors, 'link')}
                </div>
              )}

              <H3 start={0}>
                {t('activities_description', { ns: 'secret' })}
                <DefaultLabel>
                  {t('not_necessary', { ns: 'index' })}
                </DefaultLabel>
              </H3>
              <Form.Control
                as={TextareaAutosize}
                placeholder={t('activities_description_placeholder', { ns: 'secret' })}
                name={`${name}.${index}.notes`}
                value={_.get(values, `${name}[${index}].notes`)}
                onChange={(e) => handleChangeFor(`${name}[${index}].notes`, _.get(e, 'target.value', ''))}
                className={`d-flex flex-2 mt-3 mb-3 form-control form-control-lg ${_.get(errors, 'notes') ? 'is-invalid' : ''}`}
              />

              {_.get(errors, 'notes') && (
                <div className="badge badge-pill position-absolute mt-n4 badge-danger">
                  {_.get(errors, 'notes')}
                </div>
              )}

              <Button
                type="button"
                variant="outline-black"
                onClick={() => remove(index)}
                className="mt-2 rounded-0 px-5 col-md-auto"
                size="wsm"
              >
                {t('activities_delete', { ns: 'secret' })}
              </Button>
            </div>
          );
        })}
      </Form.Group>

      <ButtonControl>
        <Button
          type="button"
          onClick={() => push({ type: null })}
          size="xl"
          className="px-5 my-3 my-md-0"
          variant="outline-primary"
        >
          {t('activities_add', { ns: 'secret' })}
        </Button>
      </ButtonControl>
    </div>
  );
};

ArtActivity.defaultProps = {
  label: '',
  className: '',
  labelOutside: true,
};

ArtActivity.propTypes = {
  form: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  push: PropTypes.func.isRequired,
  remove: PropTypes.func.isRequired,
  className: PropTypes.string,
  labelOutside: PropTypes.bool,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
};

export default ArtActivity;
